export enum Language {
  LANGUAGE_UNSPECIFIED = 0,
  LANGUAGE_C = 1,
  LANGUAGE_CLOJURE = 2,
  LANGUAGE_COFFEESCRIPT = 3,
  LANGUAGE_CPP = 4,
  LANGUAGE_CSHARP = 5,
  LANGUAGE_CSS = 6,
  LANGUAGE_CUDACPP = 7,
  LANGUAGE_DOCKERFILE = 8,
  LANGUAGE_GO = 9,
  LANGUAGE_GROOVY = 10,
  LANGUAGE_HANDLEBARS = 11,
  LANGUAGE_HASKELL = 12,
  LANGUAGE_HCL = 13,
  LANGUAGE_HTML = 14,
  LANGUAGE_INI = 15,
  LANGUAGE_JAVA = 16,
  LANGUAGE_JAVASCRIPT = 17,
  LANGUAGE_JSON = 18,
  LANGUAGE_JULIA = 19,
  LANGUAGE_KOTLIN = 20,
  LANGUAGE_LATEX = 21,
  LANGUAGE_LESS = 22,
  LANGUAGE_LUA = 23,
  LANGUAGE_MAKEFILE = 24,
  LANGUAGE_MARKDOWN = 25,
  LANGUAGE_OBJECTIVEC = 26,
  LANGUAGE_OBJECTIVECPP = 27,
  LANGUAGE_PERL = 28,
  LANGUAGE_PHP = 29,
  LANGUAGE_PLAINTEXT = 30,
  LANGUAGE_PROTOBUF = 31,
  LANGUAGE_PBTXT = 32,
  LANGUAGE_PYTHON = 33,
  LANGUAGE_R = 34,
  LANGUAGE_RUBY = 35,
  LANGUAGE_RUST = 36,
  LANGUAGE_SASS = 37,
  LANGUAGE_SCALA = 38,
  LANGUAGE_SCSS = 39,
  LANGUAGE_SHELL = 40,
  LANGUAGE_SQL = 41,
  LANGUAGE_STARLARK = 42,
  LANGUAGE_SWIFT = 43,
  LANGUAGE_TSX = 44,
  LANGUAGE_TYPESCRIPT = 45,
  LANGUAGE_VISUALBASIC = 46,
  LANGUAGE_VUE = 47,
  LANGUAGE_XML = 48,
  LANGUAGE_XSL = 49,
  LANGUAGE_YAML = 50,
  LANGUAGE_SVELTE = 51,
  LANGUAGE_TOML = 52,
  LANGUAGE_DART = 53,
  LANGUAGE_RST = 54,
  LANGUAGE_OCAML = 55,
  LANGUAGE_CMAKE = 56,
  LANGUAGE_PASCAL = 57,
  LANGUAGE_ELIXIR = 58,
  LANGUAGE_FSHARP = 59,
  LANGUAGE_LISP = 60,
  LANGUAGE_MATLAB = 61,
  LANGUAGE_POWERSHELL = 62,
  LANGUAGE_SOLIDITY = 63,
  LANGUAGE_ADA = 64,
  LANGUAGE_OCAML_INTERFACE = 65,
}

export function mapLanguage(lang: string): Language {
  switch (lang) {
    case "typescript":
    case "typescriptreact":
      return Language.LANGUAGE_TYPESCRIPT;
    case "javascriptreact":
      return Language.LANGUAGE_JAVASCRIPT;
    case "css":
      return Language.LANGUAGE_CSS;
    case "rust":
      return Language.LANGUAGE_RUST;
    case "sql":
      return Language.LANGUAGE_SQL;
    case "python":
      return Language.LANGUAGE_PYTHON;
    case "vue":
      return Language.LANGUAGE_VUE;
    case "svelte":
      return Language.LANGUAGE_SVELTE;
    case "php":
      return Language.LANGUAGE_PHP;
    case "lua":
      return Language.LANGUAGE_LUA;
    case "elixir":
      return Language.LANGUAGE_ELIXIR;
    case "ruby":
      return Language.LANGUAGE_RUBY;
    case "go":
      return Language.LANGUAGE_GO;
    default:
      return Language.LANGUAGE_UNSPECIFIED;
  }
}
